import React, { useEffect, useState } from "react";
import { AvForm } from "availity-reactstrap-validation";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Card, CardBody, Col, Container, Button, Row, Label } from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import Select from "react-select";
import _ from 'lodash'
import { CircularProgress } from "@material-ui/core";

const AddPermission = (props) => {
  const [roleOptions, setRoleOptions] = useState([]);
  const [selectedRole, setSelectedRole] = useState();
  const [selectedModule, setSeletedModule] = useState();
  const [moduleOptions, setModuleOptions] = useState([]);
  const [successAlert, setSuccesAlert] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [token, setToken] = useState();
  const [addCheck, setAddCheck] = useState();
  const [updateCheck, setUpdateCheck] = useState();
  const [deleteCheck, setDeleteCheck] = useState();
  const [viewCheck, setViewCheck] = useState();
  const [selectAll, setSelectAll] = useState(false);
  const [allPermissions,setAllPermissions]=useState()
  const [loader,setLoader]=useState(false)


  useEffect(() => {
    const token = localStorage.getItem("AuthenticationToken");
    setToken(token);
    getRole(token);
    getModule(token);
    getPermissions(token);
  }, []);

  useEffect(() => {
    if (props.location.state?.edit) {
      var propsData = props.location.state?.item;
      handleEditPage(propsData);
    }
  }, [roleOptions, moduleOptions]);

  const handleEditPage = async (propsData) => {
    var roleId = propsData?.role_id;
    var moduleId = propsData?.module_id;
    var add = propsData?.add;
    var update = propsData?.update;
    var del = propsData?.delete;
    var view = propsData?.view;

    let selectedRole = roleOptions.filter((item) => {
      return item.id == roleId;
    });
    setSelectedRole(selectedRole[0]);
    let selectedModule = moduleOptions.filter((item) => {
      return item.id == moduleId;
    });
    setSeletedModule(selectedModule[0]);
    add ? setAddCheck(true) : setAddCheck(false);
    update ? setUpdateCheck(true) : setUpdateCheck(false);
    del ? setDeleteCheck(true) : setDeleteCheck(false);
    view ? setViewCheck(true) : setViewCheck(false);
  };
  const getRole = (token) => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/roles?pageSize=-1`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        let sortedArray = result?.sort(function (a, b) {
          return a.name.localeCompare(b.name);
        });
        const roleOptions = sortedArray?.map((item) => {
          return {
            id: item.id,
            value: item.name,
            label: capitalizeFirstLetter(item.name),
          };
        });
        setRoleOptions(roleOptions.filter((item)=>item.value!="merchant"));
      })
      .catch((error) => console.log("error", error));
  };

  const getModule = (token) => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/modules/?pageSize=-1`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        let sortedArray = result?.sort(function (a, b) {
          return a?.menulable.localeCompare(b?.menulable);
        });
        const moduleOptions = sortedArray?.map((item) => {
          return {
            id: item?.id,
            value: item?.name,
            label: item?.menulable,
          };
        });
        setModuleOptions(moduleOptions);
      })
      .catch((error) => console.log("error", error));
  };
  const getPermissions = (token) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append(
      "Cookie",
      "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208"
    );

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
      crossDomain: true,
    };

    fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/permissions/?pageSize=-1`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result) {
        const sortedArray=_.sortBy(result, (x)=>{
          return  x.module_lable.toLowerCase()
         })
        const sortedArray2 = sortedArray?.sort((a, b) => {
          return a.role_name.localeCompare(b.role_name);
        });         
        setAllPermissions(sortedArray2);
        }
      })
      .catch((error) => console.log(" errror", error));
  };

  const handleSubmit = () => {
    if (!selectedRole) {
      setErrorMessage("Please select Role");
      setErrorAlert(true);
      return;
    } else if (!selectedModule) {
      if (!selectAll) {
        setErrorMessage("Please Enter Module");
        setErrorAlert(true);
        return;
      }
    }

    setLoader(true)

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("cache-control", "no-cache");
    myHeaders.append(
      "Cookie",
      "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208"
    );

    var formdata = new FormData();
    if (selectAll) {
      formdata.append("role_id", selectedRole?.id);
      formdata.append("all_permissions", 1);
      formdata.append(`_method`,"PUT")
    } else {
      selectedModule?.map((item, index) => {
        formdata.append(`role_id`, selectedRole?.id);
        formdata.append(`_method`,"PUT")
        formdata.append(`modules[${index}][name]`, item?.value);
        formdata.append(`modules[${index}][id]`, item?.id);
        formdata.append(`modules[${index}][add]`, 1);
        formdata.append(`modules[${index}][update]`, 1);
        formdata.append(`modules[${index}][delete]`, 1);
        formdata.append(`modules[${index}][view]`, 1);
      });
    }

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
      processData: false,
      mimeType: "multipart/form-data",
      async: true,
      crossDomain: true,
    };

    fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/permissions/update`,
      requestOptions
    )
      .then((response) => {
        if (response.status == 200) {
          setSuccesAlert(true);
          setLoader(false)
        } else {
          setErrorMessage("Unable to Add");
          setErrorAlert(true);
          setLoader(false)
        }
      })
      .catch((error) => {
        console.log("here come error--->", error);
      });
  };
  const handleUpdate = () => {
    if (!selectedRole) {
      setErrorMessage("Please select Role");
      setErrorAlert(true);
      return;
    } else if (!selectedModule) {
      setErrorMessage("Please Enter Module");
      setErrorAlert(true);
      return;
    } else if (!addCheck && !updateCheck && !deleteCheck && !viewCheck) {
      setErrorMessage("Please select at least one Permission");
      setErrorAlert(true);
      return;
    }
    
    setLoader(true)

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("cache-control", "no-cache");
    myHeaders.append(
      "Cookie",
      "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208"
    );

    var formdata = new FormData();
    formdata.append("_method", "PUT");
    formdata.append("update_single",1)
    formdata.append("role_id", selectedRole?.id);
    formdata.append("modules[0][id]", selectedModule?.id);
    formdata.append("modules[0][name]", selectedModule?.value);
    formdata.append("modules[0][add]", addCheck ? 1 : 0);
    formdata.append("modules[0][update]", updateCheck ? 1 : 0);
    formdata.append("modules[0][delete]", deleteCheck ? 1 : 0);
    formdata.append("modules[0][view]", viewCheck ? 1 : 0);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
      processData: false,
      mimeType: "multipart/form-data",
      async: true,
      crossDomain: true,
    };

    fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/permissions/update`,
      requestOptions
    )
      .then((response) => {
        if (response.status == 200) {
          setSuccesAlert(true);
          setLoader(false)
        } else {
          setErrorMessage("Unable to Add");
          setErrorAlert(true);
          setLoader(false)
        }
      })
      .catch((error) => {
        console.log("here come error--->", error);
      });
  };

  const renderSuccessAlert = () => {
    return (
      <SweetAlert
        title="Success!"
        success
        confirmBtnBsStyle="success"
        beforeUnmount={() => {
          props?.history.push("/permissions");
          setSuccesAlert(false);
          setLoader(false)
        }}
        onConfirm={() => {
          props?.history.push("/permissions");
          setSuccesAlert(false);
          setLoader(false)
        }}
        onCancel={() => {
          setSuccesAlert(false);
        }}
      >
        {props.location.state?.edit
          ? "Permission Updated Successfuly"
          : "Permission Assigned Successfuly"}
      </SweetAlert>
    );
  };

  const renderFailureAlert = () => {
    return (
      <SweetAlert
        title="Warning!"
        warning
        confirmBtnBsStyle="warning"
        onConfirm={() => {
          setErrorAlert(false);
          setLoader(false)
        }}
      >
        {errorMessage ? errorMessage : "Error. Something went wrong."}
      </SweetAlert>
    );
  };
  const handleRolePermission = (e) => {
    let selectedRolePermisions = (allPermissions || [])
      .filter((item) => item?.role_id == e?.id)
      .map((item) => ({
        id: item?.module_id,
        value: item.module_name,
        label: item?.module_lable,
      }));
      setSeletedModule(selectedRolePermisions)
  };

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            breadcrumbItem={
              props.location.state?.edit
                ? "Update Permissions"
                : "Assign Permissions"
            }
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm className="needs-validation">
                    <Card>
                      <CardBody>
                        <Row>
                          <Col md={4}>
                            <div className="mb-3">
                              <Label>Role</Label>
                              <Select
                                isSearchable={true}
                                onChange={(e) => {
                                  setSelectedRole(e);
                                  if(!props.location.state?.edit){
                                    handleRolePermission(e)
                                  }
                                  
                                }}
                                placeholder={
                                  selectedRole
                                    ? selectedRole.label
                                    : "Please Select Role...."
                                }
                                defaultValue={selectedRole}
                                options={roleOptions}
                                maxMenuHeight={120}
                                menuPlacement="auto"
                                isDisabled={props.location?.state?.edit? true : false}
                                required
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={4}>
                            <div className="mb-3">
                              <Label>Module</Label>
                              <Select
                                isMulti={
                                  !props?.location?.state?.edit ? true : false
                                }
                                isSearchable={true}
                                onChange={(e) => {
                                  setSeletedModule(e);
                                }}
                                placeholder={
                                  selectedModule
                                    ? selectedModule.label
                                    : "Please Select Module...."
                                }
                                value={selectedModule}
                                defaultValue={selectedModule}
                                options={moduleOptions}
                                maxMenuHeight={120}
                                menuPlacement="auto"
                                isDisabled={props.location?.state?.edit? true : selectAll}
                                required
                              />
                            </div>
                          </Col>
                          {!props?.location?.state?.edit && (
                            <Col md={3} style={{ marginTop: "auto" }}>
                              <div style={{ margin: "0 0 15px 15px" }}>
                                <input
                                  id={1}
                                  type="checkbox"
                                  onClick={(e) => {
                                    setSelectAll(!selectAll);
                                  }}
                                  checked={selectAll}
                                />
                                <label style={{ paddingLeft: "10px" }}>
                                  Select All
                                </label>
                              </div>
                            </Col>
                          )}
                        </Row>
                      </CardBody>
                    </Card>
                    <Card>
                      <CardBody>
                        {props?.location?.state?.edit && <Row>
                          <Col md={4}>
                            <ul
                              style={{ justifyContent: "space-between" }}
                              className="check-section d-flex"
                            >
                              <li>
                                <input
                                  id={1}
                                  type="checkbox"
                                  onClick={(e) => {
                                    setAddCheck(!addCheck);
                                  }}
                                  checked={addCheck}
                                />
                                <label style={{ paddingLeft: "10px" }}>
                                  Add
                                </label>
                              </li>
                              <li>
                                <input
                                  id={2}
                                  type="checkbox"
                                  onClick={(e) => {
                                    setUpdateCheck(!updateCheck);
                                  }}
                                  checked={updateCheck}
                                />
                                <label style={{ paddingLeft: "10px" }}>
                                  Update
                                </label>
                              </li>
                              <li>
                                <input
                                  id={3}
                                  type="checkbox"
                                  onClick={(e) => {
                                    setDeleteCheck(!deleteCheck);
                                  }}
                                  defaultChecked={deleteCheck}
                                />
                                <label style={{ paddingLeft: "10px" }}>
                                  Delete
                                </label>
                              </li>
                              <li>
                                <input
                                  id={4}
                                  type="checkbox"
                                  onClick={(e) => {
                                    setViewCheck(!viewCheck);
                                  }}
                                  defaultChecked={viewCheck}
                                />
                                <label style={{ paddingLeft: "10px" }}>
                                  View
                                </label>
                              </li>
                            </ul>
                          </Col>
                        </Row>}
                      </CardBody>
                    </Card>

                    <div className="btn-sec">
                      <Button
                        onClick={() => {
                          props.history.push("/permissions");
                        }}
                        color="danger"
                        type="submit"
                      >
                        {" "}
                        Cancel
                      </Button>
                      <button
                      disabled={loader}
                      style={{color:"#ffffff", width:"80px",marginLeft: "10px"}}
                      className={ "btn btn-success"}
                        onClick={() => {
                          if (props?.location?.state?.edit) {
                            handleUpdate();
                          } else {
                            handleSubmit();
                          }
                        }}
                        // className="px-4"
                        color="success"
                        type="submit"
                      >
                        {loader ? <CircularProgress 
                                size={15}
                                value={100}
                                color={"white"} />
                              : "Save"}
                      </button>
                    </div>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {successAlert ? renderSuccessAlert() : null}
          {errorAlert ? renderFailureAlert() : null}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AddPermission;
